var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',[_vm._v(" "+_vm._s(_vm.$tc('stats.draft-score', _vm.label))+" "+_vm._s(_vm.$t('stats.lol.match.team-stats.stats-title.draft'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }